var _style, _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainLogin = function SvgMainLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 14.6",
    style: {
      enableBackground: "new 0 0 15 14.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Fill 1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_login_page",
    transform: "translate(-158.000000, -564.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(32.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(126.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M3.1,7.8l-2,5c-0.1,0.2,0,0.4,0.1,0.6c0.2,0.2,0.4,0.2,0.6,0.1l11.7-5.7H3.1z M1.8,1.1 C1.5,1,1.2,1.1,1.1,1.3C1,1.5,1,1.6,1.1,1.8l2,5h10.5L1.8,1.1z M14.8,8c-0.2,0.3-0.4,0.6-0.7,0.7L2.3,14.5 c-0.8,0.4-1.7,0.1-2.1-0.7c-0.2-0.4-0.2-0.9,0-1.3l2.1-5.2L0.1,2.2c-0.3-0.8,0.1-1.7,0.9-2C1.2,0,1.4,0,1.6,0 C1.8,0,2,0.1,2.3,0.2l11.9,5.7C14.9,6.3,15.2,7.2,14.8,8L14.8,8z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main_login.9ea73019.svg";
export { ForwardRef as ReactComponent };